import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { AssetSelectorQuery, SelectedAssetSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'
import { dedupe } from '@/helpers/dedupe'

type Asset = SelectedAssetSelectorQuery['assets']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedAssetSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<AssetSelectorQuery>(Query)

  const { pageInfo, items } = useCombobox<Asset>({
    pageInfo: data?.assets.pageInfo,
    querySelected: selectedData?.assets.nodes[0],
    queryCollection: data?.assets.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.name
    }),
    alphabetical: false,
  })

  return (
    <SearchableCombobox
      data={items}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="barcodeBarcodeEq"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.assets.nodes = dedupe([
            ...previousData.assets.nodes,
            ...fetchMoreResult.assets.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
